import { Component, inject } from "@angular/core";
import { TablerIconComponent } from "angular-tabler-icons";
import { MaterialModule } from "src/app/core/material.module";
import { ProductsViewMode } from "src/app/core/models/user.model";
import { EventService } from "src/app/core/services/event.service";
import { UserService } from "src/app/core/services/user.service";

@Component({
  selector: "app-products-view-mode",
  standalone: true,
  imports: [MaterialModule, TablerIconComponent],
  templateUrl: "./products-view-mode.component.html",
})
export class ProductsViewModeComponent {
  private userService = inject(UserService);
  private eventService = inject(EventService);

  viewMode: ProductsViewMode =
    this.userService.getUser().ProductsViewMode ?? "list";

  setViewMode(mode: ProductsViewMode) {
    if (this.viewMode === mode) {
      return;
    }

    this.viewMode = this.userService.setProductsViewMode(mode).ProductsViewMode;
    this.eventService.publishProductsViewModeChange(this.viewMode);
  }
}
